export default __webpack_public_path__ + "static/media/7c.2a794a14.png";